import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LoginComponent } from './components/auth/login/login.component';
import { AuthComponent } from './components/auth/auth.component';
import { RegisterComponent } from './components/auth/register/register.component';
import { ForgotPasswordComponent } from './components/auth/forgot-password/forgot-password.component';
import { SubscriptionPlanComponent } from './components/auth/subscription-plan/subscription-plan.component';
import { DashboardComponent } from './components/dashboard/dashboard.component';
import { CertificatesComponent } from './components/dashboard/certificates/certificates.component';
import { SSLChatComponent } from './components/dashboard/ssl-chat/ssl-chat.component';
import { authGuard } from './guards/auth.guard';
import { SuccessComponent } from './components/common/success/success.component';
import { SoonComponent } from './components/common/soon/soon.component';
import { MarkdownComponent } from './components/common/markdown/markdown.component';
import { PenComponent } from './components/dashboard/pen/pen.component';
import { BaseLayoutComponent } from './layouts/base/base.component';
import { GuideListComponent } from './components/guide-list/guide-list.component';
import { ResetPasswordComponent } from './components/reset-password/reset-password.component';
import { TransactionDetailsComponent } from './components/transaction-details/transaction-details.component';
import { KeyRotationChatComponent } from './components/dashboard/key-rotation-chat/key-rotation-chat.component';
import { WebsocketTestComponent } from './components/websocket-test/websocket-test.component';

const routes: Routes = [
  {
    path: 'auth',
    component: AuthComponent,
    children: [
      {
        path: '',
        component: LoginComponent,
      },
      {
        path: 'register',
        component: RegisterComponent,
      },
      {
        path: 'forgot-password',
        component: ForgotPasswordComponent,
      },
      {
        path: 'choose-plan',
        component: SubscriptionPlanComponent,
      },
    ],
  },

  {
    path: 'payment/success',
    component: SuccessComponent,
  },

  {
    path: '',
    component: BaseLayoutComponent,
    canActivate: [authGuard],
    children: [
      {
        path: '',
        component: DashboardComponent,
      },
      {
        path: 'dashboard',
        component: DashboardComponent,
      },
      {
        path: 'certificates',
        component: CertificatesComponent,
      },
      {
        path: 'key-rotation',
        component: CertificatesComponent,
      },
      {
        path: 'pen',
        component: PenComponent,
      },

      {
        path: 'chat/rotate-keys',
        component: KeyRotationChatComponent,
      },
      {
        path: 'chat/rotate-keys/:id',
        component: KeyRotationChatComponent,
      },
      {
        path: 'chat',
        component: SSLChatComponent,
      },
      {
        path: 'chat/:id',
        component: SSLChatComponent,
      },
      {
        path: 'guide',
        component: GuideListComponent,
      },
      {
        path: 'my-orders',
        component: TransactionDetailsComponent,
      },
      {
        path: 'subscription',
        component: SubscriptionPlanComponent,
      },
      {
        path: 'websocket-test',
        component: WebsocketTestComponent,
      },
      {
        path: 'reset-password/:id',
        component: ResetPasswordComponent,
      },
    ],
  },
  // KEEP THIS LAST! ALWAYS, because there's a wildcard in it
  {
    path: '**',
    component: SoonComponent, // Wildcard route for undefined paths
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { onSameUrlNavigation: 'reload', scrollPositionRestoration: 'enabled'} )],
  exports: [RouterModule],
})
export class AppRoutingModule {}
